import { cn } from '@repo/utils/cn';
import Image, { StaticImageData } from 'next/image';
import { ReactNode } from 'react';

type BannerProps = {
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  img?: string | StaticImageData;
  button?: ReactNode;
  className?: string;
  contentClassName?: string;
  titleClassName?: string;
  subTitleClassName?: string;
  imageClassName?: string;
  imageHeight?: number;
  imageWidth?: number;
};

const Banner = ({
  title,
  img,
  subTitle,
  button,
  className,
  contentClassName,
  titleClassName,
  subTitleClassName,
  imageClassName,
  imageHeight,
  imageWidth,
}: BannerProps) => {
  return (
    <article
      dir="ltr"
      data-testid="banner"
      className={cn(
        '@container/banner animate-in fade-in relative w-full cursor-default overflow-hidden duration-1000',
        className
      )}
    >
      {img && (
        <Image
          quality={100}
          width={imageWidth || 100}
          height={imageHeight || 100}
          priority
          src={img}
          alt="Banner"
          unoptimized
          sizes="100vw"
          className={cn('h-[180px] w-full rounded-md object-cover sm:h-[200px]', imageClassName)}
        />
      )}
      <div
        className={cn(
          'absolute inset-0 z-50 flex h-full w-full flex-col items-start justify-between p-3 sm:p-5',
          contentClassName
        )}
      >
        <div className="flex flex-col items-start justify-center space-y-1 sm:space-y-1.5">
          <div
            className={cn(
              'vt-colors-white vt-font-highlight-font-family flex flex-col gap-1 text-left text-lg font-black italic sm:text-2xl rtl:text-right',
              titleClassName
            )}
            style={{
              textShadow: 'rgb(0, 0, 0) 9px 6px 9px',
            }}
            data-testid="banner-title"
          >
            {title}
          </div>
          {subTitle && (
            <span
              className={cn(
                'vt-colors-white vt-font-highlight-font-family block w-full text-left text-sm font-semibold italic sm:text-base rtl:text-right',
                subTitleClassName
              )}
              style={{ textShadow: 'rgb(0, 0, 0) 9px 6px 9px' }}
              data-testid="banner-sub-title"
            >
              {subTitle}
            </span>
          )}
        </div>
        <div
          dir="ltr"
          className="flex w-full cursor-pointer items-center"
          data-testid="banner-cta"
        >
          {button}
        </div>
      </div>
    </article>
  );
};

export default Banner;
